export const ItemTypes = {
    COURSE_CODE: 'courseCode'
}